import React from 'react'
import { useLocation } from 'react-router-dom'

const NotPage = () => {

  const location = useLocation();

  return (
    <div className='h-[92vh] text-center p-5 flex flex-col justify-center items-center shadow-inner'>
      <div className='text-base font-bold flex flex-col justify-center items-center gap-3'>
        <img src="vapemarket_logo.png" alt="logo" className='w-24' />
        <p><span>vapemarket.cafe24.com</span><span className='text-red-500/80 animate-pulse duration-200'>{location.pathname}</span></p>
        <p>존재하지 않는 페이지입니다. URL을 다시 확인해 주세요.</p>
      </div>
    </div>
  )
}

export default NotPage